import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2c28fa81"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ErrorMsg" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("ul", {
      onMousewheel: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["prevent"]))
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errorMsgInfo, (item, index) => {
        return (_openBlock(), _createElementBlock("li", { key: index }, [
          _createElementVNode("a", {
            class: _normalizeClass({ info: item.level == 0, errtip: item.level == 1 }),
            style: {"cursor":"pointer"}
          }, _toDisplayString(item.info), 3)
        ]))
      }), 128))
    ], 32)
  ]))
}